import { Button, Link } from 'components'
import React from 'react'

import { ArrowRightIcon } from '@radix-ui/react-icons'

import { DiscountIcon } from '../assets/Icon'

const BootcampStartNotification = ({
  start_date,
  duration,
  to
}: {
  start_date: string
  duration: string
  to: string
}) => {
  return (
    <div className="flex flex-row gap-20 items-enter justify-center">
      <div className="flex flex-col gap-2">
        <p>Starting on</p>
        <p className="text-3xl font-bold">{start_date}</p>
      </div>
      <div className="flex flex-col gap-2">
        <p>Duration</p>
        <p className="text-3xl font-bold">{duration}</p>
      </div>
      <div className="flex flex-row gap-3 items-center">
        <DiscountIcon />
        <div className="flex flex-col gap-2">
          <p className="text-xl font-bold">
            Don&lsquo;t Miss an Early Bird offer
          </p>
          <p>Limited Seats Available</p>
        </div>
      </div>
      <div className="flex flex-row items-center">
        <Link href={to}>
          <Button size="large" rounded="small" className="">
            Apply Now <ArrowRightIcon className="w-5 h-5" />
          </Button>
        </Link>
      </div>
    </div>
  )
}

export default BootcampStartNotification
